import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getRawModelPreview } from '@/app/assets/actions/rawModel';
import { RawModelPreview } from '@/types/rawModel';

interface UseRawModelPreviewOptions {
  modelId: number;
  token?: string;
}

export const useRawModelKey = () => {
  return ['rawModelPreview'];
};

export const useFetchRawModelPreview = (
  { modelId, token }: UseRawModelPreviewOptions,
  options?: Omit<UseQueryOptions<RawModelPreview | null>, 'queryKey' | 'queryFn'>
) => {
  const queryKey = [...useRawModelKey(), { modelId, token }];

  return useQuery({
    ...options,
    queryKey,
    placeholderData: (prev) => prev,
    queryFn: async () => await getRawModelPreview(modelId),
    throwOnError: false,
  });
};
